module.exports = __webpack_public_path__ + "img/student_girl.db90586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/student_girl.png
// module id = 1Hd8
// module chunks = 1